export default __webpack_public_path__ + "static/media/make-dollar.34967572.svg";